import { render, staticRenderFns } from "./TemplatesMenu.vue?vue&type=template&id=a1d7159c"
import script from "./TemplatesMenu.vue?vue&type=script&lang=js"
export * from "./TemplatesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports